"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMAGE_SEARCH_MAX_EXTRA_IMAGES = exports.IMAGE_SEARCH_DEFAULT_MIN_SCORE = exports.IMAGE_SEARCH_MAX_LIMIT = exports.IMAGE_SEARCH_DEFAULT_LIMIT = exports.IMAGE_UPLOAD_MAX_FILES = exports.IMAGE_ALLOWED_MIME_TYPES = exports.IMAGE_HISTOGRAM_BINS = exports.IMAGE_FEATURE_VERSION = exports.IMAGE_FEATURE_STATUS = void 0;
// 이미지 특징 추출 상태 (api·web·admin 공통)
exports.IMAGE_FEATURE_STATUS = {
    PENDING: "PENDING",
    PROCESSING: "PROCESSING",
    DONE: "DONE",
    FAILED: "FAILED",
};
// 특징 추출 알고리즘 버전. 알고리즘/벡터 구성이 바뀌면 올려서 재추출 대상을 구분한다.
exports.IMAGE_FEATURE_VERSION = 1;
// 색상 히스토그램: 채널당 4단계 양자화 (4 x 4 x 4 = 64 bin)
exports.IMAGE_HISTOGRAM_BINS = 64;
// 허용 업로드 이미지 MIME 타입
exports.IMAGE_ALLOWED_MIME_TYPES = [
    "image/jpeg",
    "image/png",
    "image/webp",
];
// 한 번에 업로드 가능한 이미지 수
exports.IMAGE_UPLOAD_MAX_FILES = 10;
// 이미지 비교 검색
exports.IMAGE_SEARCH_DEFAULT_LIMIT = 10;
exports.IMAGE_SEARCH_MAX_LIMIT = 50;
// 기본 최소 유사도 (0~1). 이보다 낮은 후보는 추천에서 제외한다.
exports.IMAGE_SEARCH_DEFAULT_MIN_SCORE = 0.3;
// 추천 항목에 포함할 추가 사진 최대 개수 (대표 사진 제외)
exports.IMAGE_SEARCH_MAX_EXTRA_IMAGES = 4;
